import { Type, type Static } from '@sinclair/typebox';

export const UpdatePasswordBodySchema = Type.Object({
  current_password: Type.String(),
  password: Type.String({ minLength: 8 }),
});

export const UpdatePasswordFormSchema = Type.Composite([
  UpdatePasswordBodySchema,
  Type.Object({
    password_confirmation: Type.String(),
  }),
]);

export const SetPasswordBodySchema = Type.Object({
  password: Type.String({ minLength: 8 }),
});
export const SetPasswordFormSchema = Type.Composite([
  SetPasswordBodySchema,
  Type.Object({
    password_confirmation: Type.String(),
  }),
]);

export type UpdatePasswordBody = Static<typeof UpdatePasswordBodySchema>;
export type UpdatePasswordForm = Static<typeof UpdatePasswordFormSchema>;
export type SetPasswordBody = Static<typeof SetPasswordBodySchema>;
export type SetPasswordForm = Static<typeof SetPasswordFormSchema>;
